export default __webpack_public_path__ + "static/media/bgvideo2.63d1b767.mp4";